/* Scentica — animaciones ligeras (sin librerías) */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (!reduce) root.classList.add('sc-motion');
  if (!('IntersectionObserver' in window)) return;
  var IO = function(cb, o){ return new IntersectionObserver(cb, o); };

  /* Contadores */
  function countUp(el){
    var end = parseFloat(el.getAttribute('data-sc-count')); if (isNaN(end)) return;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var fmt = function(n){ return dec ? n.toFixed(dec) : Math.round(n).toLocaleString('en-US'); };
    if (reduce) { el.textContent = fmt(end); return; }
    var t0 = performance.now(), dur = 3000;
    (function step(t){ var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(end * e); if (p < 1) requestAnimationFrame(step); })(t0);
  }
  var cio = IO(function(es){ es.forEach(function(e){ if (e.isIntersecting){ countUp(e.target); cio.unobserve(e.target); } }); }, {threshold: .6});
  document.querySelectorAll('[data-sc-count]').forEach(function(el){ cio.observe(el); });

  /* Elementos que se activan al verse: estrellas, precio tachado */
  var vio = IO(function(es){ es.forEach(function(e){ if (e.isIntersecting){ var t = e.target; vio.unobserve(t);
    setTimeout(function(){ requestAnimationFrame(function(){ t.classList.add('is-in'); }); }, 350); } }); }, {threshold: .35});
  document.querySelectorAll('[data-sc-stars], .sc-insp').forEach(function(el){ vio.observe(el); });

  /* Aparición suave de secciones (home) */
  if (!reduce && location.pathname === '/') {
    var secs = document.querySelectorAll('main .shopify-section');
    var rio = IO(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); rio.unobserve(e.target); } }); }, {threshold: .08});
    secs.forEach(function(s){ if (s.getBoundingClientRect().top > innerHeight * .9) { s.classList.add('sc-reveal'); rio.observe(s); } });
  }


  /* Explosión de ingredientes en celular: en pantallas sin hover, la tarjeta cambia a su 2ª imagen al quedar a la vista */
  var touch = matchMedia('(hover: none)').matches || innerWidth < 990;
  if (touch && !reduce) {
    var fio = IO(function(es){ es.forEach(function(e){
      var w = e.target;
      if (e.isIntersecting) { w._scT = setTimeout(function(){ w.classList.add('sc-flip'); }, 450); }
      else { clearTimeout(w._scT); w.classList.remove('sc-flip'); }
    }); }, {threshold: .55});
    var seen = new WeakSet();
    function watchCards(root){
      (root.querySelectorAll ? root.querySelectorAll('.card-wrapper[data-sc-flip]') : []).forEach(function(w){
        if (seen.has(w) || !w.querySelector('.media--hover-effect > img + img')) return;
        seen.add(w); fio.observe(w);
      });
    }
    watchCards(document);
    new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes.forEach(function(n){ if (n.nodeType === 1) watchCards(n); }); }); })
      .observe(document.body, {childList: true, subtree: true});
  }

  /* Barra fija de compra (ficha) */
  var bar = document.querySelector('[data-sc-sticky]');
  var buy = document.querySelector('.product-form__submit');
  if (bar && buy) {
    bar.hidden = false;
    var sio = IO(function(es){ es.forEach(function(e){
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-show', show);
      root.classList.toggle('sc-sticky-on', show);
    }); }, {threshold: 0});
    sio.observe(buy);
    bar.querySelector('[data-sc-sticky-buy]').addEventListener('click', function(){ buy.click(); });
  }

  /* Frasco que vuela al carrito */
  function inView(el){ var r = el.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < innerHeight; }
  function fly(img){
    if (reduce || !img) return;
    var cart = document.querySelector('#cart-icon-bubble'); if (!cart) return;
    var a = img.getBoundingClientRect(), b = cart.getBoundingClientRect(); if (!a.width) return;
    var c = img.cloneNode(true); c.removeAttribute('loading');
    c.style.cssText = 'position:fixed;left:'+a.left+'px;top:'+a.top+'px;width:'+a.width+'px;height:'+a.height+'px;z-index:9999;border-radius:12px;object-fit:cover;pointer-events:none;margin:0';
    document.body.appendChild(c);
    var dx = b.left + b.width/2 - (a.left + a.width/2), dy = b.top + b.height/2 - (a.top + a.height/2);
    var anim = c.animate([
      {transform:'translate(0,0) scale(1)', opacity:1},
      {transform:'translate('+dx*.55+'px,'+(dy*.55-140)+'px) scale(.45)', opacity:.95, offset:.55},
      {transform:'translate('+dx+'px,'+dy+'px) scale(.06)', opacity:.4}
    ], {duration: 850, easing: 'cubic-bezier(.45,0,.2,1)'});
    anim.onfinish = function(){ c.remove(); cart.classList.add('sc-bump'); setTimeout(function(){ cart.classList.remove('sc-bump'); }, 600); };
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.product-form__submit, [data-sc-add], .quick-add__submit');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var img = null, it;
    if ((it = btn.closest('.sc-up__item'))) img = it.querySelector('img');
    else if ((it = btn.closest('.card-wrapper'))) img = it.querySelector('.card__media img');
    else {
      var main = document.querySelector('.product__media img');
      img = (main && inView(main)) ? main : (bar && bar.querySelector('img'));
    }
    fly(img);
  }, true);

  /* Tarjeta Maison con inclinación 3D */
  if (!reduce) document.querySelectorAll('.sc-maison--up').forEach(function(card){
    card.addEventListener('pointermove', function(e){
      if (e.pointerType !== 'mouse') return;
      var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      card.style.transform = 'perspective(800px) rotateX(' + (-y * 7) + 'deg) rotateY(' + (x * 9) + 'deg)';
      card.style.setProperty('--mx', ((x + .5) * 100) + '%'); card.style.setProperty('--my', ((y + .5) * 100) + '%');
    });
    card.addEventListener('pointerleave', function(){ card.style.transform = ''; });
  });
})();
